// extracted by mini-css-extract-plugin
export default {"name":"hMGyKhgxjbIqdkOX4iSD","metric":"g0JhheMdX90jQrSVCFtm","metricBig":"fIHuWxVP6sTqL0uf3S34"};